<template lang="pug">
nav(:class='navClass')
	component.pagination-item.pagination-cta.pagination-cta--prev(
		tabindex="0"
		:class="{disabled: !enablePrev}", 
		:is="enablePrev ? 'a' : 'span'", 
		@click.stop.prevent="enablePrev ? moveIndex(-1) : false", 
		aria-label="Previous results page")
		i.ico-arrow_back 
		| Prev
	component.pagination-item(v-for="(item, index) in results.totalPages",
		tabindex="0"
		:key="index",
		:is="index === query.currentPage ? 'span' : 'a'",
		:class="{ 'pagination-item--current': index === query.currentPage, 'pagination__ellipsis': !checkPaginationVisibility(index)}",
		@click.stop.prevent="index === query.currentPage ? false : selectIndex(index)") 
		span.pagination-itemInner(v-if="checkPaginationVisibility(index)") {{ index + 1 }}
	component.pagination-item.pagination-cta.pagination-cta--next(
		tabindex="0"
		:class="{disabled: !enableNext}", 
		:is="enableNext ? 'a' : 'span'", 
		@click.stop.prevent="enableNext ? moveIndex(1) : false", 
		aria-label="Next results page")
		| Next
		i.ico-arrow_forward

</template>

<script>
import $screen from '../../../../js/utils/_screen'
export default {
	props: {
		small: Boolean
	},
	created() {
		if (!window.pageListener) {
			window.pageListener = (e) => {
				if (e.key == 'ArrowLeft' && this.enablePrev) {
					// left
					this.moveIndex(-1);
				}

				else if (e.key == 'ArrowRight' && this.enableNext) {
					//right
					this.moveIndex(1);
				}
			}
			window.addEventListener("keydown", window.pageListener);
		}
	},
	methods: {
		selectIndex: function (index) {
			this.$emit("submitPage", index);
		},
		moveIndex: function (increment) {
			let newIndex = this.query.currentPage + increment;
			this.selectIndex(newIndex);
		},
    screenSize: function(){
      if ($screen.md.matches) {
        return true;
      }
      else{
        return false;
      }

    },
		resetIndex: function () {
			this.selectIndex(0);
		},
		checkPaginationVisibility(i) {
			let cp = this.currentPage;
			let tp = this.results.totalPages;

			if (tp <= 9) return true;
			if (i === 0) return true
			if (i === tp - 1) return true

			if (cp < 4) {
				if (i < 4) return true;
			}

			if (Math.abs(cp - i) <= 2) return true

			if (cp > tp - 5) {
				if (i > tp - 5) return true;
			}

			return false;
		},
	},
	computed: {
		navClass: function() {
			if (this.small) {
					return "pagination pagination--rightAlign pagination--small";
			}
			else {
					return "pagination"
			}
		},
		currentPage() {
			return this.query.currentPage;
		},
		settings: function () {
			return this.$store.state.settings;
		},
		enablePrev: function () {
			return this.query.currentPage > 0;
		},
		enableNext: function () {
			return this.query.currentPage + 1 < this.results.totalPages;
		},
		results: function () {
			return this.$store.state.results;
		},
		query: function () {
			return this.$store.state.searchQuery;
		},
	},
  mounted(){
    let  paginationSmall = document.querySelector('.pagination:not(.pagination--small)');
    if(!this.screenSize() && paginationSmall !== null){
      paginationSmall.classList.add('pagination--small');
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  .pagination-cta--prev{
    @include mqdn(md){
      margin-right:.3rem
    }
  } 
  .pagination-cta--next{
    @include mqdn(md){
      margin-left:.3rem
    }
  } 
  .pagination--small &{
    &__ellipsis {
      @include fluid(height, 0.875rem, 1.125rem);
      @include fluid(width, 0.875rem, 1.125rem);
      max-height: unset;
      max-width: unset;
	  }
  }
	&__ellipsis {
			display: flex;
			align-items: center;
			justify-content: center;
			align-self: center;
      max-height: 1.125rem;
      @include fluid(max-height, 0.875rem, 2.5rem);
      @include fluid(max-width, 0.875rem, 2.5rem);

			padding: 0.25rem;
      &:hover{
        text-decoration: none;
      }
			& + & {
				display: none;
			}
      &:before {
        content:'...';
      }
	}

}
</style>